import styled, { keyframes } from 'styled-components';
import Variables from 'styles/Variables';

export const Overlay = styled.div`
	background-color: rgba(0, 0, 0, 0.75);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	height: 100vh;
	z-index: 10000;
	display: flex;
	align-items: stretch;
	justify-content: center;

	@media (min-width: 768px) {
		align-items: center;
		padding: 2rem;
	}
`;

export const ModalContent = styled.div`
	background: #fff;
	width: 100%;
	height: 100vh;
	max-width: 100vw;
	display: flex;
	flex-direction: column;
	position: relative;
	overflow: hidden;

	@media (min-width: 768px) {
		max-width: 480px;
		height: auto;
		max-height: calc(100vh - 4rem);
		border-radius: 1rem;
	}
`;

export const ModalHeader = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	padding: 1rem 1.25rem;
	border-bottom: 1px solid #eee;
	flex-shrink: 0;
	background: #fff;
`;

export const ScrollArea = styled.div`
	flex: 1 1 auto;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	padding: 1.25rem 1rem 1.5rem;

	@media (min-width: 768px) {
		padding: 1.5rem;
	}
`;

export const ModalTitle = styled.h2`
	font-size: 1.125rem;
	font-weight: 600;
	margin: 0;
`;

export const CloseButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 0.25rem;
	color: #333;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TicketCard = styled.div`
	background: #fff;
	border: 1px solid #e4e4e4;
	border-radius: 0.75rem;
	overflow: hidden;
	box-shadow: ${Variables.boxShadows.level2};
	max-width: 400px;
	width: 100%;
	margin: 0 auto;
`;

export const TicketBanner = styled.div<{ thumbnail?: string }>`
	background-image: url(${({ thumbnail }) => thumbnail || `${process.env.REACT_APP_BUCKET_URL}/images/banner-fallback.jpg`});
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 120px;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 40px;
		background: linear-gradient(transparent, rgba(0, 0, 0, 0.3));
	}
`;

export const TicketBody = styled.div`
	padding: 1rem;
`;

export const EventName = styled.h3`
	font-size: 1rem;
	font-weight: 700;
	margin: 0 0 0.75rem;
	color: #212121;
`;

export const InfoRow = styled.div`
	align-items: flex-start;
	display: flex;
	margin-bottom: 0.5rem;
	gap: 0.5rem;

	svg {
		flex-shrink: 0;
		margin-top: 2px;
		color: ${Variables.colors.main};
	}
`;

export const InfoText = styled.span`
	font-size: 0.8125rem;
	color: #555;
	line-height: 1.4;
`;

export const Divider = styled.div`
	border-top: 1px dashed #d0d0d0;
	margin: 0.75rem 0;
	position: relative;

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: -8px;
		width: 16px;
		height: 16px;
		background: #f5f5f5;
		border-radius: 50%;
	}

	&::before { left: -24px; }
	&::after { right: -24px; }
`;

export const AttendeeName = styled.p`
	font-size: 0.9375rem;
	font-weight: 600;
	margin: 0 0 0.25rem;
	color: #212121;
`;

export const TicketType = styled.p`
	font-size: 0.8125rem;
	color: #555;
	margin: 0 0 0.125rem;
`;

export const QRCodeWrapper = styled.div`
	background: #ffffff;
	border-radius: 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 1rem 0 0.5rem;
	padding: 0.75rem;
`;

export const AttendeeCode = styled.p`
	font-size: 0.75rem;
	color: #777;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin: 0.5rem 0 0;
	font-weight: 500;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	margin: 1.5rem auto 0;
	max-width: 400px;
	width: 100%;

	@media (min-width: 768px) {
		flex-direction: row;
	}
`;

export const ActionButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
	align-items: center;
	border-radius: 0.5rem;
	cursor: pointer;
	display: flex;
	font-family: inherit;
	font-size: 0.875rem;
	font-weight: 600;
	gap: 0.5rem;
	justify-content: center;
	padding: 0.75rem 1rem;
	transition: opacity 0.2s;
	width: 100%;

	background: ${({ variant }) => variant === 'secondary' ? 'transparent' : Variables.colors.main};
	border: 2px solid ${Variables.colors.main};
	color: ${({ variant }) => variant === 'secondary' ? Variables.colors.main : '#fff'};

	&:hover {
		opacity: 0.85;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

const spin = keyframes`
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
	animation: ${spin} 1s linear infinite;
	border: 2px solid transparent;
	border-radius: 50%;
	border-top-color: currentColor;
	height: 1rem;
	width: 1rem;
`;
